(function() {
  angular.module('curalate').service('EcommerceIntegrationsApiService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
            /**
             * Validate Tokens
             */
      this.validateMagentoTokens = function(magentoStoreUrl, magentoAccessToken) {
        const params = {
          feedUrl: magentoStoreUrl,
          magentoAccessToken,
        };

        return PromiseService.processHttpResponse($http.get('/api/integrations/ecommerce/magento/verify-token', { params }));
      };

      this.validateShopifyTokens = function(shopifyAccountName, shopifyApiKey, shopifyAccessToken, storefrontAccessToken) {
        const params = {
          shopifyAccountName,
          shopifyApiKey,
          shopifyAccessToken,
          storefrontAccessToken,
        };

        return PromiseService.processHttpResponse($http.get('/api/integrations/ecommerce/shopify/verify-token', { params }));
      };

            /**
             * Create Catalogs
             */
      this.createMagentoCatalog = (feedUrl, magentoAccessToken, locale) => {
        return PromiseService.processHttpResponse($http.post('/api/integrations/ecommerce/magento', {
          feedUrl,
          magentoAccessToken,
          locale,
        })).then((response) => { return response; });
      };

      this.createShopifyCatalog = function(shopifyAccountName, shopifyApiKey, shopifyAccessToken, storefrontAccessToken, locale) {
        return PromiseService.processHttpResponse($http.post('/api/integrations/ecommerce/shopify', {
          shopifyAccountName,
          shopifyApiKey,
          shopifyAccessToken,
          storefrontAccessToken,
          locale,
        })).then((response) => { return response; });
      };

      this.getFirstCatalogAcquisition = (catalogId) => {
        const params = {
          catalogId,
        };
        return PromiseService.processHttpResponse($http.get('api/integrations/ecommerce/acquisition', { params }));
      };
    },
  ]);
})();
